import apiClient from '../client';

export type StagePhase = 'unset' | 'scheduled' | 'active' | 'ended';
export type LiveView = 'idle' | 'countdown' | 'live';

export interface StageStatus {
  stage: 1 | 2;
  term: 1 | 2;
  label: string;
  phase: StagePhase;
  startTime: string | null;
  endTime: string | null;
  inProgressCount: number;
  completedCount: number;
}

export interface LiveStatusData {
  serverTime: string;
  durationMs: number;
  stages: StageStatus[];
  view: LiveView;
  activeStage: 1 | 2 | null;
  activeTerm: 1 | 2 | null;
  countdownStage: 1 | 2 | null;
  countdownTerm: 1 | 2 | null;
  countdownTarget: string | null;
}

export const liveApi = {
  getLiveStatus: async (): Promise<LiveStatusData> => {
    const res = await apiClient.get<{ success: boolean; data: LiveStatusData }>('/results/live-status');
    return res.data.data;
  },
};
